export default __webpack_public_path__ + "static/media/regulatory--no-stopping--g1.4fd0a542.png";